import {
  notifyIceServers,
  notifyAgentAddress,
  notifyNrcErrorResponse,
  dummyAction,
  notifyUserDetails
} from '../../actions/signaling'
import { logger } from './../utils/logger'

export class TransportMessageParser {
  constructor (routeMessageParser) {
    this.routeMessageParser = routeMessageParser
    this.parseMap = {
      'netop.rc.base.NRCErrorResponse': (binaryMsg) => {
        const msg = proto.netop.rc.base.NRCErrorResponse.deserializeBinary(binaryMsg)
        const obj = msg.toObject()
        const action = notifyNrcErrorResponse(obj.error)
        return action
      },

      'netop.rc.portal.cm.GetIceInfoResponse': (binaryMsg) => {
        const msg = proto.netop.rc.portal.cm.GetIceInfoResponse.deserializeBinary(binaryMsg)
        const obj = msg.toObject()

        const action = notifyIceServers({
          stunList: obj.stunList,
          turnList: obj.turnList,
          turnServersList: obj.turnServersList,
        })
        return action
      },

      'netop.rc.route.RouteMessage': this.routeMessageParser.parse,

      'netop.rc.route.ResolveAgentAddressResponse': (binaryMsg) => {
        const agentAddressResponse = proto.netop.rc.route.ResolveAgentAddressResponse.deserializeBinary(binaryMsg)
        const objAgentAdressesResponse = agentAddressResponse.toObject()
        const action = notifyAgentAddress({
          agentAddress: objAgentAdressesResponse.addressesList.length > 0 ? objAgentAdressesResponse.addressesList[0] : null
        })
        return action
      },

      'netop.rc.route.ResolveAddressResponse': (binaryMsg) => {
        const agentAddressResponse = proto.netop.rc.route.ResolveAddressResponse.deserializeBinary(binaryMsg)
        const objAgentAdressesResponse = agentAddressResponse.toObject()
        const action = notifyAgentAddress({
          agentAddress: objAgentAdressesResponse.addressesList.length > 0 ? objAgentAdressesResponse.addressesList[0] : null
        })
        return action
      },

      'netop.rc.portal.cm.GetUserDetailsFromTokenResponse': (binaryMsg) => {
        const userDetailsResponse = proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.deserializeBinary(binaryMsg)
        const objUserDetailsResponse = userDetailsResponse.toObject()

        const userDetails = objUserDetailsResponse.details

        const action = notifyUserDetails({
          clientFirstName: userDetails.firstname,
          clientLastName: userDetails.lastname
        })
        return action
      },

    }
  }

  default = (type) => () => {
    // ignore silently the messages with unknown type
    // ex. netop.rc.portal.cm.ListAgentsResponse, netop.rc.portal.cm.ListRemoteControlDevicesResponse
    logger(` - unknown transport message type ${type}`)
    return dummyAction()
  }

  parse = (binaryMessage) => {
    const msg = proto.netop.rc.transport.Message.deserializeBinary(binaryMessage)
    const body = msg.getBody()
    const transportBodyMessage = proto.netop.rc.base.NRCMessageType.deserializeBinary(body)
    const type = transportBodyMessage.getNetopMessageType()

    const parser = this.parseMap[type] || this.default(type)
    return parser(body)
  }
}

